export { default as LogoText } from './LogoText';
